import { useState } from "react"
import ReactDOM from "react-dom";

import Button from "../../../common/Button"
import Backdrop from "../../../common/modal/Backdrop";
import Modal from "../../../common/Modal";
import ModalInnerWrapper from "../../../common/ModalInnerWrapper";
import CreateLiabilityForm from "../forms/CreateLiabilityForm";
import { useUserTabEditPermissionDisabled } from "../../../../lib/usersPermissions";


const CreateLiability = ({folder, apiCase, permission}) => {

    let userPermissionDisabled = useUserTabEditPermissionDisabled(permission)

    const [modalOpned, setModalOpened] = useState(false)

    const openModalHandler = () => {
        setModalOpened(true)
    }

    const closeModalHandler = () => {
        setModalOpened(false)
    }

    return <>
        {userPermissionDisabled && <Button btnStyle={'btn_light_grey'} click={openModalHandler}><i className="ti ti-square-plus"></i>Create</Button>}
        {modalOpned && <>
            {ReactDOM.createPortal(
                <Backdrop hide={closeModalHandler} />,
                document.getElementById("backdrop-root")
            )}  
            {ReactDOM.createPortal(
                <Modal>
                    <ModalInnerWrapper closeModal={closeModalHandler} modalTitle={'New Insurance Carrier'}>
                        <CreateLiabilityForm closeModal={closeModalHandler} folder={folder} apiCase={apiCase}/>
                    </ModalInnerWrapper>
                </Modal>,
                document.getElementById("overlay-root")
            )}          
        </>}
    </>
}

export default CreateLiability